var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 13C1.2325 13 0.832433 12.841 0.4998 12.5231C0.167167 12.2051 0.000566667 11.8224 0 11.375V1.625C0 1.17812 0.1666 0.795708 0.4998 0.47775C0.833 0.159791 1.23307 0.000541667 1.7 0H15.3C15.7675 0 16.1678 0.15925 16.501 0.47775C16.8342 0.79625 17.0006 1.17867 17 1.625V11.375C17 11.8219 16.8337 12.2046 16.501 12.5231C16.1684 12.8416 15.7681 13.0005 15.3 13H1.7ZM8.5 7.3125L15.3 3.25V1.625L8.5 5.6875L1.7 1.625V3.25L8.5 7.3125Z",
    fill: "#0038A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8ed34824146ec52047a912fe8e661802.svg";
export { ForwardRef as ReactComponent };